import React from 'react';
import PropTypes from 'prop-types';
import { Button, Popover } from 'module-tsl-ui-elements';
import EnhancedSelect from './EnhancedSelect';
import EnhancedInputGroup from './EnhancedInputGroup';

var SellerData = function SellerData(_ref) {
  var titles = _ref.titles,
      countries = _ref.countries,
      onHideModal = _ref.onHideModal;
  return /*#__PURE__*/React.createElement("section", {
    className: "padding-md"
  }, /*#__PURE__*/React.createElement("header", {
    className: "l-flex-vcenter-spaced margin-bottom-md"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "heading heading--medium"
  }, "Personal Details"), /*#__PURE__*/React.createElement(Popover, {
    content: "We will never share your details with third parties",
    placement: "left",
    push: "left",
    tooltipBehavior: true
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon icon-tds-info-1 icon-blue icon-xxl"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "seller-registration-modal__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement(EnhancedSelect, {
    name: "title",
    label: "Title",
    options: titles
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "firstname",
    label: "First Name"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "lastname",
    label: "Last Name"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "seller-registration-modal__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(EnhancedSelect, {
    name: "country",
    label: "Country",
    options: countries
  }), /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "address_line1",
    label: "Address"
  }), /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "address_line2"
  }), /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "address_line3"
  }), /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "city",
    label: "City or Town"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-6"
  }, /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "postalcode",
    label: "Postal Code"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-6"
  }, /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "state",
    label: "State"
  })))))), /*#__PURE__*/React.createElement("footer", {
    className: "l-flex padding-top-ml"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    type: "submit",
    className: "seller-registration-modal__cta"
  }, "Next"), /*#__PURE__*/React.createElement(Button, {
    theme: "secondary",
    type: "button",
    onClick: onHideModal,
    className: "seller-registration-modal__cta"
  }, "Cancel")));
};

SellerData.displayName = "SellerData";
SellerData.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  onHideModal: PropTypes.func.isRequired
};
export default SellerData;